import React, {Fragment, useEffect, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";


export default function DebtReport(){
    let state=useSelector((state)=> state);
    const [DebtDivision, setDebtDivision]=useState([]);
    const [DebtCircle, setDebtCircle]=useState([]);
    const [DataCoEffeciant, setDataCoEffeciant]=useState([]);
    const [ColumnCoEfficient, setColumnCoEfficient]=useState([{}]);
    const [DataLength, setDatalength]=useState(0);
    const [BinDebt, setBinDebt]=useState();
    const [NameDebt, setNameDebt]=useState();
    const[DataStatus, setDataStatus]=useState(false);

    const[DebtHistory, setDebtHistory]=useState([]);


    const [ShowDebtOption, setShowDebtOption] = useState(false);
    const handleCloseDebtOption = () => setShowDebtOption(false);
    const handleShowDebtOption = () => setShowDebtOption(true);

    const [ShowDebt, setShowDebt] = useState(false);
    const handleCloseDebt = () => setShowDebt(false);
    const handleShowDebt = () => setShowDebt(true);


    const [ShowDebtDetailes, setShowDebtDetailes] = useState(false);
    const handleCloseDebtDetailes = () => setShowDebtDetailes(false);
    const handleShowDebtDetailes = () => setShowDebtDetailes(true);

    const [ShowDebtEdit, setShowDebtEdit] = useState(false);
    const handleCloseDebtEdit = () => setShowDebtEdit(false);
    const handleShowDebtEdit = () => setShowDebtEdit(true);



    const selectRowDebt={
        mode:'radio',
        onSelect: (row,isSelect,rowIndex)=> {

             setBinDebt();
            setBinDebt(row['BIN']);
            setNameDebt(row['Name']);

            handleShowDebtOption();



        }
    }
    const getDebtHistory=()=>{

        let jsonObject={"sql":"SELECT BIN,Details FROM nbr.debt_details where BIN='"+BinDebt+"' "};
        setDebtHistory([0]);
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");setShowDebtDetailes(false);}else {
                await setDebtHistory(result);
                setShowDebtDetailes(true);


            }
        }).catch(error=>{ });

    }
    const saveDebtUpdate=()=>{

        const DebtDetails=document.getElementById("txtAreaDebtDetails").value;


        let jsonObject={"sql":"insert into debt_details (Id,BIN,Details)values(NULL,'"+BinDebt+"','"+DebtDetails+"') "};
        if(DebtDetails==""){cogoToast.error("Please insert update data")}else
        {


            RestClient.PostRequest(AppUrl.saveData, jsonObject).then(async result => {

                if (result ==1) {
                    cogoToast.success("Data Saved");

                } else {
                    cogoToast.error("Data not Saved");

                }
            }).catch(error => {
                cogoToast.error("Data not Saved");
            });
        }
    }
    const getDebtData=()=>{
        setDataStatus(true);

        const DebtCommi=document.getElementById("cmbDebtCommi");
        const DebtCommiValue=DebtCommi.options[DebtCommi.selectedIndex].text;

        const DivisionDebt=document.getElementById("cmbDebtDivision");
        const DivisionDebtValue=DivisionDebt.options[DivisionDebt.selectedIndex].text;

        const CircleDebt=document.getElementById("cmbAuditBinCircle");
        const CircleDebtValue=CircleDebt.options[CircleDebt.selectedIndex].text;

        const BinCategoryDebt=document.getElementById("cmbAuditBinCategory");
        const CategoryDebtValue=BinCategoryDebt.options[BinCategoryDebt.selectedIndex].text;
        let getCommiDebt=" ";
        let getDivisionDebt=" ";
        let getCircleDebt=" ";
        let getCategoryDebt=" ";
        if(DebtCommi.selectedIndex!=0){getCommiDebt="And Commissionerate Like '%"+DebtCommiValue+"%'"}
        if(DivisionDebt.selectedIndex!=0){getDivisionDebt="And Division Like '%"+DivisionDebtValue+"%'"}
        if(CircleDebt.selectedIndex!=0){getCircleDebt="And Circle Like '%"+CircleDebtValue+"%'"}
        if(BinCategoryDebt.selectedIndex!=0){getCategoryDebt="And Economic_Activity Like '%"+CategoryDebtValue+"%'"}

        let jsonObject={"sql":" Select Debt_report.Id,bin.Circle,bin.Name,bin.BIN,Debt_report.Total_Amount,Debt_report.Collected_Amount,Debt_report.Left_Amount,Debt_report.Upto_Collection,Debt_report.Current_Month_Collection AS Current_Month from bin inner join Debt_report on bin.BIN=Debt_report.BIN "}

        setColumnCoEfficient([{}]);setDataCoEffeciant([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length);
            setDataStatus(false);
            if(result==""){cogoToast.error("Data not found")}else {
                await setColumnCoEfficient(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciant(result);
                setDataStatus(false);

            }
        }).catch(error=>{});
    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDebtCommi"
                                            onChange={()=>{
                                                setDebtDivision([]);
                                                setDebtCircle([]);
                                                const e = document.getElementById("cmbDebtCommi");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDebtDivision(dt)


                                            }}
                                    >




                                        <option >NBR</option>



                                        {


                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDebtDivision"
                                            onChange={()=>{
                                                setDebtCircle([])
                                                const e = document.getElementById("cmbDebtDivision");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setDebtCircle(dt)


                                            }}
                                    >
                                        <option>All Division</option>

                                        {


                                            DebtDivision.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDebtBinCircle" >
                                        <option>All Circle</option>

                                        {


                                            DebtCircle.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbAuditBinCategory"  >
                                        <option >All BIN</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}>

                                </Col>
                                <Col lg={9}>
                                    <button className="w-100" onClick={getDebtData}>Search</button>
                                </Col>


                            </Row>
                            <Row className="mt-4">
                                <Col lg={3}>

                                </Col>
                                <Col lg={9}>
                                    <button className="mt-4 text-danger" onClick={handleShowDebt}>New Debt Entry</button>
                                </Col>


                            </Row>


                        </div>
                    </Col>

                    <Col lg={9}>
                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">

                            {
                                DataStatus?<LoadingText/>
                                    :  <BootstrapTable   keyField='Id' selectRow={selectRowDebt} data={DataCoEffeciant} columns={ColumnCoEfficient}></BootstrapTable>

                            }
                           </div>
                        <label className="text-danger customfontsize">Data found: {DataLength}</label>

                    </Col>

                </Row>

            </div>
            <Modal show={ShowDebt} onHide={handleCloseDebt}>
                <Modal.Header closeButton>

                    <label>New Debt Entry</label>

                </Modal.Header>
                <Modal.Body>
                    <div><label>BIN:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Total Amount:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Collected Amount:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Left Amount:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>UpTo Collection:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Current Month Collection:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Type:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Adj.Date:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Last Action Date:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Year:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Status:</label><input type="text" id="txtDebtBin"/></div><hr/>
                    <div><label>Comments:</label><input type="text" id="txtDebtBin"/></div><hr/>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseDebt}>Close</Button>
                    <Button variant="danger" >Save</Button>


                </Modal.Footer>
            </Modal>
            <Modal show={ShowDebtOption} onHide={handleCloseDebtOption}>
                <Modal.Header closeButton>

                    <label>{NameDebt}</label>
                    <label className="text-danger">-BIN:</label>
                    <label>{BinDebt}</label>

                </Modal.Header>
                <Modal.Body>
                    <Button variant="primary" className="m-4" onClick={getDebtHistory}>Show History</Button>
                    <Button variant="secondary" onClick={handleShowDebtEdit}>Edit History</Button>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseDebtOption}>Close</Button>



                </Modal.Footer>
            </Modal>
            <Modal show={ShowDebtDetailes} onHide={handleCloseDebtDetailes} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>Debt Detailes:{NameDebt}</label>

                </Modal.Header>
                <Modal.Body >
                    {
                        DebtHistory.map((ctr,index)=>{
                            return (
                                <div> <label>{ctr.Details}</label>
                                    <hr/>
                                </div>
                            )
                        })
                    }

                    <div className="">
                       <textarea className="w-100 h-75" rows="10" id="txtAreaDebtDetails"></textarea>
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseDebtDetailes}>Close</Button>
                    <Button variant="primary" onClick={saveDebtUpdate} >Save</Button>


                </Modal.Footer>
            </Modal>
            <Modal show={ShowDebtEdit} onHide={handleCloseDebtEdit} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>Debt Detailes:{NameDebt}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                        <div className="wide-content">

                        </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseDebtEdit}>Close</Button>
                    <Button variant="danger" >Save</Button>


                </Modal.Footer>
            </Modal>

        </Fragment>

    )
}
